var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84,0.307 C3.704,0.307 0.34,3.537 0.34,7.507 C0.34,11.478 3.704,14.707 7.84,14.707 C11.975,14.707 15.34,11.478 15.34,7.507 C15.34,3.537 11.975,0.307 7.84,0.307 Z",
    id: "Path",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.062,7.92 C2.062,7.423 2.482,7.02 2.999,7.02 C3.517,7.02 3.937,7.423 3.937,7.92 C3.937,8.418 3.517,8.82 2.999,8.82 C2.482,8.82 2.062,8.418 2.062,7.92 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,5.67 L3.75,6.48 L2.25,6.48 L2.25,4.32 L3,4.32 C3.827,4.32 4.5,3.674 4.5,2.88 C4.5,2.085 3.827,1.44 3,1.44 C2.171,1.44 1.5,2.085 1.5,2.88 L0,2.88 C0,1.293 1.345,0 3,0 C4.653,0 6,1.293 6,2.88 C6,4.22 5.041,5.35 3.75,5.67 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.baefe6c2dd1d716776604dd9f6b04e90.svg";
export { ForwardRef as ReactComponent };